export const GET_LOCATIONS = "GET_LOCATIONS";
export const GET_ALL_GEO_LOCATIONS = "GET_ALL_GEO_LOCATIONS";
export const CREATE_LOCATION = "CREATE_LOCATION";
export const REMOVE_LOCATIONS = "REMOVE_LOCATIONS";
export const SET_ACTIVE_LOCATION = "SET_ACTIVE_LOCATION";
export const SET_USER_TYPE_FILTER = 'SET_USER_TYPE_FILTER'